import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vuetify'
import App from './App.vue'
import Vuetify from 'vuetify'
import firebase from 'firebase'
import router from './router'
import swal from 'sweetalert';

Vue.use({
  install (Vue) {
    Vue.swal = swal
    Vue.prototype.$swal = swal
  }
})
Vue.use(Vuetify)
Vue.use(firebase)
Vue.config.productionTip = false

var config = {
  apiKey: "AIzaSyAgD90ciofkky-gI3vpjQsd8u67hSMUOwc",
  authDomain: "yh-search.firebaseapp.com",
  databaseURL: "https://yh-search.firebaseio.com",
  projectId: "yh-search",
  storageBucket: "",
  messagingSenderId: "86545234047"
};

firebase.initializeApp(config);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
